/* eslint-disable @typescript-eslint/ban-ts-comment */
import 'twin.macro'
import { useEffect, useId, useRef, useState } from 'react'
import { useLocation } from '@reach/router'
import LabelFloating from './label-floating'

interface Props extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label: string
  initialValue?: string
  onUpdate?: (arg: string, ref?: HTMLSelectElement) => void
  fields: string[]
  tooltip?: string
}

export default function RadioFieldset(props: Props): JSX.Element {
  const { label, initialValue, value, onUpdate, fields, tooltip, ...inputProps } = props
  const ref = useRef<HTMLSelectElement>()
  const uid = useId()
  const { search } = useLocation()

  const [hasFocus, setFocus] = useState(false)
  const [input, setInput] = useState(initialValue || value)

  useEffect(() => {
    const defVal = new URLSearchParams(search).get(inputProps.name) || (initialValue as string)
    if (defVal) setInput(defVal)

    if (document.hasFocus() && ref.current === document.activeElement) setFocus(true)
  }, [])

  useEffect(() => {
    if (value && value !== input) setInput(value)
  }, [value])

  return (
    <LabelFloating
      label={label}
      uid={uid}
      hasFocus={hasFocus}
      hasInput
      required={inputProps.required}
      name={inputProps.name}
      tooltip={tooltip}
    >
      <div tw="p-3">
        {fields.map((field) => (
          <label key={field} tw="block">
            <input
              tw="mr-1"
              type="radio"
              name={inputProps.name}
              value={field}
              checked={input === field}
              disabled={inputProps.disabled}
              onChange={(event) => {
                setInput(event.target.value)
                if (onUpdate) onUpdate(event.target.value)
              }}
            />
            {field}
          </label>
        ))}
      </div>
    </LabelFloating>
  )
}
